module.exports = __webpack_public_path__ + "img/qr_code_icon.b23a1255.svg";